import React from 'react';
import { lazy } from 'react-loosely-lazy';
import Icon from '@atlaskit/icon';
import { AutomationGlyph } from '@atlassian/jira-automation-menu/src/common/assets/automation';
import Placeholder from '@atlassian/jira-placeholder';
import { IconWrapper } from './ui/main';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AutomationMenu = lazy(
	() => import(/* webpackChunkName: "async-releases-automation-menu" */ './index'),
);

const fallback = (
	// eslint-disable-next-line jira/integration/test-id-by-folder-structure
	<IconWrapper data-testid="jira-releases-automation-menu.ui.automation-button.disabled">
		<Icon glyph={AutomationGlyph} label="" />
	</IconWrapper>
);

const AsyncReleaseAutomationMenu = () => (
	<Placeholder name="releases-automation-menu" fallback={fallback}>
		<AutomationMenu />
	</Placeholder>
);

export default AsyncReleaseAutomationMenu;
